<div class="sso">
  <div class="sso-loading">
    <mat-progress-bar [color]="'primary'" mode="buffer" />
  </div>
</div>
